export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13987.2918f968.jpg";